// Sentinel id for the read-only, computed system template. Backend exposes it
// at `/contracts/templates/system/` — no DB id, no timestamps. We give it a
// stable client-side id so routes (`/contracts/system`) and list lookups work
// uniformly with user rows.
export const SYSTEM_TEMPLATE_ID = "system";

// Shared "Set as Default" enabled/tooltip logic for a template, used by the
// list row, the mobile card, and the editor so the copy stays consistent.
//
// Only the current default is disabled — any other template (including the
// System Built-in when it isn't currently the default) can be promoted.
export const getSetDefaultState = (template) => {
  const disabled = !template || template.is_default;
  const title = template?.is_default
    ? "This template is already your default."
    : "Set as default template";
  return { disabled, title };
};
